import { Flame } from 'lucide-react';

interface AttendanceFlameProps {
  // Tailwind colour classes (text-* / fill-*) layered on top of the default
  // size. Defaults to the parent text colour so callers can keep their own
  // colour scheme; pass a class to override.
  className?: string;
}

// Single source of truth for the attendance "flame" indicator used across
// the heatmaps (full-week marker) and the monthly streak badge. Centralising
// the size keeps the signal consistent — change the dimension here and every
// surface updates together.
export default function AttendanceFlame({ className = '' }: AttendanceFlameProps) {
  return <Flame className={`w-3.5 h-3.5 ${className}`.trim()} />;
}
